export default "__VITE_ASSET__BPEcj1_H__"